module.exports = __webpack_public_path__ + "static/10gde-8a64eb8c81dd256c0c58cec1725eba6b.gif";